import { matchPath } from 'react-router-dom';
import { routes } from 'routes/route-paths';
import { StepNumber } from 'types/stepper/stepper.type';
import { GoToStepProps } from 'types/stepper/stepper.type';

export const reportStepToRoute = (step: GoToStepProps['step']) => {
  switch (step) {
    case 1:
      return routes.reportsRoutes.newReportRoutes.selectClients;
    case 2:
      return routes.reportsRoutes.newReportRoutes.reportPeriod;
    case 3:
      return routes.reportsRoutes.newReportRoutes.review;
    default:
      return routes.reportsRoutes.newReportRoutes.selectClients;
  }
};

export const reportRouteToStep = (pathName: string): StepNumber | undefined => {
  if (matchPath(routes.reportsRoutes.newReportRoutes.selectClients, pathName)) {
    return 1;
  }
  if (matchPath(routes.reportsRoutes.newReportRoutes.reportPeriod, pathName)) {
    return 2;
  }
  if (matchPath(routes.reportsRoutes.newReportRoutes.review, pathName)) {
    return 3;
  }

  return;
};
